import useGetOrganizationFromCache from '@/hooks/queries/organization-api/useGetOrganizationFromCache';
import useGetUserFromCache from '@/hooks/queries/users-api/useGetUserFromCache';
import { VEPCodes } from '@/lib/utils';
import type { TUser } from '@/services/user';
import type { Role } from '@/utils/roles';
import { useNavigate } from 'react-router-dom';

const useQuickActions = () => {
  const organization = useGetOrganizationFromCache();
  const userData = useGetUserFromCache();
  const navigate = useNavigate();
  const codeOrganization = organization?.code;

  const navigateBasedOnRole = (userRole: Role) => {
    if (userRole === 'Monitor') {
      navigate(`/attendance`);
    } else {
      navigate(`/sales`);
    }
  };

  const handleNavigation = (userData: TUser) => {
    const userRole = userData?.userType?.name ?? 'Customer';
    if (VEPCodes.includes(codeOrganization ?? '')) {
      navigateBasedOnRole(userRole);
    }
  };

  return {
    userData,
    handleNavigation
  };
};

export default useQuickActions;
